import _core from "../core.js";
import _component from "../component.js";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Visible = void 0;
const core_js_1 = _core;
const component_js_1 = _component;
class Visible extends component_js_1.Component {
  constructor() {
    super(...arguments);
    this.isVisible = false;
  }
  didMount() {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          observer.disconnect();
          this.isVisible = true;
          this.update();
        }
      });
    }, {
      threshold: [0, 1]
    });
    observer.observe(this.elements[0]);
  }
  render() {
    if (!this.isVisible) {
      return (0, core_js_1.h)("div", {
        "data-visible": false,
        visibility: "hidden"
      });
    } else {
      if (this.props.onVisible) this.props.onVisible();
      return (0, core_js_1.render)(this.props.component || this.props.children[0]);
    }
  }
}
exports.Visible = Visible;
//# sourceMappingURL=visible.js.map
export default exports;